<div class="w-full max-w-3xl">
  <ng-container *transloco="let t">
    <!-- Form -->
    <form [formGroup]="form" (ngSubmit)="save()">
      <!-- Section Profile -->
      <section class="bg-card rounded-2xl ring-1 ring-black/5 dark:ring-white/10 shadow-sm overflow-hidden">
        <!-- Card Header -->
        <div class="flex items-center justify-between px-6 py-5 border-b">
          <div>
            <div class="text-lg font-semibold leading-tight">{{ t('profile') | titlecase }}</div>
            <div class="text-secondary text-sm mt-1">
              {{ t('company-settings.account.profile.description') }}
            </div>
          </div>
          <div class="w-24 flex flex-col items-center">
            <hmax-input-upload-file [images]="logoImages" [isLoading]="isUploadingLogo" [maxImages]="1"></hmax-input-upload-file>
            <mat-label class="text-gray-500">{{ t('change-logo') | capitalize }}</mat-label>
          </div>
        </div>

        <!-- Card Body -->
        <div class="grid sm:grid-cols-3 gap-4 px-6 py-5">
          <!-- Company -->
          <div class="sm:col-span-3">
            <mat-form-field class="fuse-mat-no-subscript w-full">
              <mat-label>{{ t('company') | capitalize }}</mat-label>
              <mat-icon class="icon-size-5" svgIcon="heroicons_solid:building-office" matPrefix></mat-icon>
              <input formControlName="company" matInput />
            </mat-form-field>
          </div>

          <!-- Document -->
          <div class="sm:col-span-1">
            <mat-form-field class="fuse-mat-no-subscript w-full">
              <mat-label>{{ t('document') | capitalize }}</mat-label>
              <mat-icon class="icon-size-5" svgIcon="heroicons_solid:briefcase" matPrefix></mat-icon>
              <input formControlName="document" matInput />
            </mat-form-field>
          </div>

          <!-- Email -->
          <div class="sm:col-span-1">
            <mat-form-field class="fuse-mat-no-subscript w-full">
              <mat-label>Email</mat-label>
              <mat-icon class="icon-size-5" svgIcon="mat_outline:email" matPrefix></mat-icon>
              <input formControlName="email" matInput />
            </mat-form-field>
          </div>

          <!-- Phone -->
          <div class="sm:col-span-1">
            <mat-form-field class="fuse-mat-no-subscript w-full">
              <mat-label>{{ t('phone') | capitalize }}</mat-label>
              <mat-icon class="icon-size-5" svgIcon="heroicons_solid:phone" matPrefix></mat-icon>
              <input formControlName="phone" matInput />
            </mat-form-field>
          </div>
        </div>
      </section>

      <!-- Divider -->
      <div class="my-4 border-t"></div>

      <!-- Section Default -->
      <section class="w-full">
        <div class="text-xl">{{ t('default') | titlecase }}</div>

        <!-- Line 1 -->
        <div class="grid sm:grid-cols-4 gap-4 w-full mt-6">
          <!-- Language -->
          @if (shouldShowOptions('language')) {
            <div class="sm:col-span-2">
              <hmax-input-select
                appearance="fill"
                [showEmptyOption]="false"
                [optionTranslate]="true"
                [options]="optionsLanguage"
                label="language"
                [formGroup]="form"
              >
              </hmax-input-select>
            </div>
          }

          <!-- Timezone -->
          @if (shouldShowOptions('timezone')) {
            <div class="sm:col-span-2">
              <hmax-input-select
                appearance="fill"
                [showEmptyOption]="false"
                [options]="optionsTimeZones"
                label="timezone"
                [formGroup]="form"
              >
              </hmax-input-select>
            </div>
          }
        </div>
      </section>

      <!-- Divider -->
      <div class="my-4 border-t"></div>

      <section class="w-full">
        <!-- Actions -->
        <div class="flex items-center justify-end">
          <button mat-stroked-button type="button" (click)="cancel()">
            {{ t('cancel') | titlecase }}
          </button>
          <button class="ml-4 dark:bg-blue-600" mat-flat-button type="submit" [disabled]="!enableSubmitButton" color="primary">
            {{ t('save') | titlecase }}
          </button>
        </div>
      </section>
    </form>
  </ng-container>
</div>
